import React from 'react';
import {
    Grid, Row, Col,
    Nav, NavItem, ControlLabel,
    Tab, Form, FormGroup, FormControl
} from 'react-bootstrap';
import Card from '../../components/Card/Card.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';

class EvaluationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldValues: this.props.evaluacion,
      fieldErrors: {},
      parcialScores: {},
    };
    this.onChangeFields = this.onChangeFields.bind(this);
    this.generateForms = this.generateForms.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
    this.getParcialScore = this.getParcialScore.bind(this);
    this.getTotalScore = this.getTotalScore.bind(this);
  }

  onChangeFields(value, maxValue, name, position) {
    const auxFieldValues = this.state.fieldValues;
    const idCriterio = this.state.fieldValues[name][position].idcriterio;
    auxFieldValues[name][position].valor = parseInt(value, 10);
    this.setState({
      fieldValues: auxFieldValues,
    });
    this.validateInput(value, maxValue, idCriterio);
  }

  validateInput(value, maxValue, formName) {
    const regex = new RegExp(`[0-${maxValue}]`); // Dynamic RegExp :D
    const auxFieldErrors = this.state.fieldErrors;
    if (regex.test(value) && value.length === 1) {
      auxFieldErrors[formName] = false;
    } else {
      auxFieldErrors[formName] = true;
    }
    this.setState({ fieldErrors: auxFieldErrors });
  }

  checkErrors() {
    const aux = this.state.fieldErrors;
    let error = false;
    Object.keys(aux).forEach((key, index) => { // Iterar en el objecto buscando errores true.
      if (aux[key]) {
        error = true;
      }
    });
    return error;
  }

  generateForms(array, name, maxValue) {
    const formGroups = [];
    array.forEach((item, index) => {
      formGroups.push(
        <FormGroup key={item.idcriterio}>
          <Col componentClass={ControlLabel} sm={8}>
            {item.criterio}
          </Col>
          <Col sm={4}>
            <FormControl
              type="number" onChange={(e) => this.onChangeFields(e.target.value, maxValue, name, index)}
              defaultValue={!item.valor ? 0 : item.valor}
            />
            {this.state.fieldErrors[item.idcriterio] &&
              <small className="text-danger">
                {`Sólo números de 0 a ${maxValue}`}
              </small>
            }
          </Col>
        </FormGroup>
      );
    });
    return (
      <Form horizontal>
        {formGroups}
      </Form>
    );
  }

  getParcialScore(tab, multiplier, divider) {
    if (this.checkErrors()) {
      return '?';
    }
    let sum = 0;

    this.state.fieldValues[tab].forEach((item, index) => { // Iterar en el objecto obteniendo calificaciones.
      if (item.valor) {
        sum += parseInt(item.valor, 10);
      }
    });
    let result = multiplier * (sum / divider);
    result = +result.toFixed(2);
    return result;
  }

  getTotalScore() {
    if (this.checkErrors()) {
      return '?';
    }
    const projectScore = this.getParcialScore('Proyecto', 1, this.props.evaluacion.Proyecto.length);
    const teamScore = this.getParcialScore('Equipo', 1, this.props.evaluacion.Equipo.length);
    const extrasScore = this.getParcialScore('Extras', 0.6, 1);

    let result = (projectScore + teamScore + extrasScore) / 3;
    result = +result.toFixed(2);

    return result;
  }

  convertData(respuestas) {
    const auxArray = [];
    Object.keys(respuestas).forEach((key) => { // Iterar en el objecto buscando errores true.
      respuestas[key].forEach((item) => {
        const auxObject = {};
        auxObject.idcriterio = item.idcriterio;
        auxObject.valor = item.valor;
        auxArray.push(auxObject);
      });
    });
    return(auxArray);
  }

  render() {
    return (
      <Card
        title="Evaluación"
        content={
          <Grid fluid >
            <Row>
              <Col md={12}>
                <Tab.Container defaultActiveKey="proyect" id="evaluacion" >
                    <Row className="clearfix">
                        <Col sm={12}>
                            <Nav bsStyle="tabs">
                                <NavItem eventKey="proyect">
                                    <i className="fa fa-briefcase"></i> Proyecto
                                </NavItem>
                                <NavItem eventKey="team">
                                    <i className="fa fa-users"></i> Equipo
                                </NavItem>
                                <NavItem eventKey="extras">
                                    <i className="fa fa-file-text"></i> Adicionales
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col sm={12}>
                            <Tab.Content animation>
                                <Tab.Pane eventKey="proyect">
                                    {this.generateForms(this.props.evaluacion.Proyecto, 'Proyecto', 3)}
                                    <div className="footer">
                                        <hr />
                                        <div className="stats" style={{ float: 'right' }}>
                                          {`Calificación parcial: ${this.getParcialScore('Proyecto', 1, this.props.evaluacion.Proyecto.length)}`}
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="team">
                                    {this.generateForms(this.props.evaluacion.Equipo, 'Equipo', 3)}
                                    <div className="footer">
                                        <hr />
                                        <div className="stats" style={{ float: 'right' }}>
                                          {`Calificación parcial: ${this.getParcialScore('Equipo', 1, this.props.evaluacion.Equipo.length)}`}
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="extras">
                                    {this.generateForms(this.props.evaluacion.Extras, 'Extras', 1)}
                                    <div className="footer">
                                        <hr />
                                        <div className="stats" style={{ float: 'right' }}>
                                          {`Calificación parcial: ${this.getParcialScore('Extras', 0.6, 1)}`}
                                        </div>
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                            <div className="footer">
                                <hr />
                                <div className="stats" style={{ float: 'right' }}>
                                  {`Calificación Total: ${this.getTotalScore()}`}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Tab.Container>
              </Col>
            </Row>
          </Grid>
        }
        legend={
          <div style={{ textAlign: "right"}}>
            <Button
              bsStyle="info"
              fill={true}
              wd={true}
              onClick={() => this.props.savePreEvaluation(this.convertData(this.state.fieldValues), this.getTotalScore())}
              disabled={this.checkErrors()}
            >
              Guardar evaluación
            </Button>
          </div>
        }
      />
    );
  }
}

export default EvaluationPanel;



// WEBPACK FOOTER //
// ./src/views/Incubation/EvaluationPanel.jsx